const isDev = globalThis?.location?.protocol !== 'https:';

export const env = {
  wsUrl: isDev ? 'ws://localhost:3000' : 'wss://api-2025.hackvegas.lol',
  tvUrl: isDev ? 'http://localhost:3003' : 'https://tv-2025.hackvegas.lol',
};
